import { render, staticRenderFns } from "./ImportDocuments.vue?vue&type=template&id=24b22931&"
import script from "./ImportDocuments.vue?vue&type=script&lang=js&"
export * from "./ImportDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports